export const getComments = (
  conversationId: string,
  email: string = "",
  userName: string,
  userUid: string
) => {
  return fetch(`${process.env.URL_BIBLIOTECAS_SERVICES}/community/api/v1/post-detail?postId=${
    conversationId}${email ? "&email=" + email : ""}`)
    .then(async res => {
      const response = await res.json();
      if (response.status === 400) {
        await createUser(email, userName, userUid);
        return await getComments(conversationId, email, userName, userUid);
      }
      return {
        comments: response.data.responses,
        userId: response.data.userId
      };
    })
    .catch(err => console.log(err));
}

export const likeComment = (type: string, commentaryId: string, email: string) => {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      commentaryId,
      type
    })
  }
  return fetch(`${process.env.URL_BIBLIOTECAS_SERVICES}/community/api/v1/commentary-like`, options)
    .then(async res => {
      const response = await res.json();
      return response.status;
    })
    .catch(err => console.log(err))
}

export const createUser = (email: string, name: string, uid: string) => {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      name,
      uid
    })
  }
  return fetch(`${process.env.URL_BIBLIOTECAS_SERVICES}/community/api/v1/register`, options)
    .then(async res => {
      const response = await res.json();
      return response.status;
    })
    .catch(err => console.log(err))
}